export default __webpack_public_path__ + "static/media/rnr-sports-table-25-cn.a69c5260.webp";